import CoordMapType from '../../map/coordMapType'
import EventEmitter from '../../vendor/EventEmitter'
import MapAdapter from './mapAdapter'
import AudioPlayer from './audioPlayer'
import Common from '../common'
import MediaModules from '../mediaModules'
import mobileMenu from '../../mobileMenu'
import WebMapDelegate from './webMapDelegate'
import Browser from '../../Browser'
import { MapMarker, BubbleText, initDirectionsConfiguration } from './coordinates_v3'
import $ from 'jquery'
import DirectionsController from './DirectionsController'

class MapController {
    constructor() {
        this._location = null
        this._selectedStop = null
        this._stops = null
        this.trails = null
        this.startingStop = null
        this.delegate = null
        this.currentStop = null
        this.tooltipOverlay = null
        this.multiplyer = null
        this.stopRange = 20
        this.mapMarkers = []
        this.hasPolygons = false
        this.map = null
        this.currentHoverStopId = -1
        this.markersVisible = null
        try {
            this._currentStopId = $('#dropmenudiv .selected', parent.document.body).data('id')
        } catch (e) {
            // console.log(e)
        }
        this._currentAudioId = null
        this._msg = null
        this._firstRun = true
        this._directions = null // directions controller
        this._recenterOnAccurateGPSUpdate = true
        this.isMobile = false
        this._eventEmitter = EventEmitter ? new EventEmitter() : null
        this.events = {
            STOP_SELECTED: 'stopSelected',
            SUPPLEMENTAL_MEDIA_SELECTED: 'supplementalMediaSelected',
            MAP_READY: 'mapReady',
        }
    }

    switchMarkerIcon = wpId => {
        var marker = this.getStopById(wpId).marker
        if (marker.currentIcon) {
            marker.setIcon(marker.currentIcon)
            marker.currentIcon = null
        } else {
            marker.currentIcon = marker.getIcon()
            marker.setIcon(this.activeStopIcon)
            setTimeout('switchMarkerIcon(' + wpId + ')', 500)
        }
    }
    getStopById = id => {
        var i
        for (i = 0; i < this._stops.length; i++) {
            if (this._stops[i].id == id) {
                return this._stops[i]
            }
        }
        return null
    }

    Init = loc => {
        this._location = loc
        this._isMobile = loc.isMobilePhone
        this._isFullMap = loc.isFullMap
        this._gpsCollector = loc.gpsCollector || false
        this.startingStop = this._currentStopId ? this._currentStopId : loc.startingStop

        initDirectionsConfiguration(loc)

        MapAdapter.setController(this)

        var mapOptions = {
            center: loc.mapCenter,
            gestureHandling: 'greedy',
            zoom: loc.mapZoom,
            minZoom: loc.minZoom || null,
            maxZoom: loc.maxZoom || null,
            panControl: false,
            draggingCursor: 'move',
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            enableGoogleBar: true,
            fullscreenControl: false,
            zoomControl: loc.zoomControl !== 'undefined' ? loc.zoomControl : true,
            disableDoubleClickZoom: loc.disableDoubleClickZoom !== 'undefined' ? loc.disableDoubleClickZoom : false,
            backgroundColor: loc.backgroundColor || '#000',
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.TOP_LEFT,
            },
        }
        this.coordinateMapType = new CoordMapType()
        this.coordinateMapType.CustomGetTileUrl = this.CustomGetTileUrl
        var scope = this
        this.map = new google.maps.Map(document.getElementById('campusmap'), mapOptions)

        // overwrite double click behavior to do nothing
        google.maps.event.addDomListener(this.map, 'dblclick', loc.onDoubleClick || function() {})

        if (!loc.hasGoogleMap) {
            this.map.mapTypes.set('coordinate_' + this._location.loc_id, this.coordinateMapType)
            this.map.setMapTypeId('coordinate_' + this._location.loc_id)
        } else if (loc.allowMapTypeControl) {
            this.map.set('mapTypeControl', true)
        }

        if (MapAdapter.automaticAudioEnabled) {
            MapAdapter.enableAutomaticAudio(!this._isMobile)
        }
        MapAdapter.setColorInstitutionOverride(loc.inst_id)
        this.campusMapInit(this, this.map, 130, 20, loc.hasGoogleMap)

        if (loc.onZoom) {
            google.maps.event.addDomListener(this.map, 'zoom_changed', () => {
                loc.onZoom({ level: this.map.getZoom() })
            })
        }
        if (loc.drawCircle) {
            this.initMapMarkers(loc.mapMarkers)
        }

        // Check if location has directions feature enabled
        if (loc.hasDirections) {
            // Initialize correct version of directions controller
            this.initDirections(loc.stops, this._isMobile)
        }

        if (loc.trailPoints) {
            this.initTrailPoints(loc.trailPoints)
        }

        this.initStops(loc.stops)
        this.initTrails(loc.trails)
        this.initLocateMe()
        this.initShareButton()

        this.player = new AudioPlayer()
        $('#audioPlayer').bind('play', () => {
            this._onAudioPlayerPlay(this.player)
        })
        $('#audioPlayer').bind('pause', () => {
            this._onAudioPlayerStop(this.player)
        })
        $('#audioPlayer').bind('ended', () => {
            this._onAudioPlayerEnded(this.player)
        })
        $('#audioPlayer').bind('timeupdate', function(event) {
            var value = Math.floor((100 / this.duration) * this.currentTime)
            $('.audioProgress').css('width', value + '%')
        })
        mobileMenu.init('container', 'container')
        if (typeof MediaModules != 'undefined') {
            MediaModules.init({
                locid: this._location.loc_id,
                instid: this._location.inst_id,
                containerType: MediaModules.containerTypes.STOP,
                currentStopCallback: () => {
                    return this._selectedStop
                },
            })
                .onOpen(() => {
                    if (this.isMobile()) mobileMenu.rightMenu()
                })
                .onClose(() => {
                    if (this.isMobile()) mobileMenu.rightMenu()
                })
        } else {
            $('.mediaPanelPopup').on('touchstart click', '.modules [class*=module-]', () => {
                var className = $(this).attr('class'),
                    matches = /module-(icon-)?([\S]+)/.exec(className),
                    mediaType = matches[matches.length - 1],
                    newStop = this._selectedStop
                this.supplementalMediaListener(mediaType, newStop.id)
                return false
            })
        }
        this._selectedStop = this._stops[0]
        window.addEventListener('message', this.stopsListener.bind(this), false)
    }
    destroy = () => {
        if (this.map) {
            this.map = null
            if (this.initTimeout) {
                clearTimeout(this.initTimeout)
                this.initTimeout = null
            }
        }
        if (this.tooltipOverlay) {
            this.tooltipOverlay = null
        }
    }
    isFullMap = () => {
        return this._isFullMap
    }
    isMobilePhone = () => {
        return this._isMobile
    }
    initTrailPoints = trails => {
        for (var index in trails) {
            trails[index].setMap(this.map)
        }
    }
    isMobile = () => {
        return typeof this._isMobile !== 'undefined' ? this._isMobile : Browser.is('Mobile')
    }

    supplementalMediaListener = (media, stopid) => {
        this._eventEmitter && this._eventEmitter.trigger(this.events.SUPPLEMENTAL_MEDIA_SELECTED, [media, stopid])
    }

    onSupplementalMediaSelected = cb => {
        this._eventEmitter && this._eventEmitter.on(this.events.SUPPLEMENTAL_MEDIA_SELECTED, cb)
    }

    onMapReady = cb => {
        this._eventEmitter && this._eventEmitter.on(this.events.MAP_READY, cb)
    }

    stopsListener = event => {
        if (event.origin.indexOf('youvisit.com') >= 0) {
            return
        }
        var currentStop = event.data
        this.selectStop(currentStop.id)
    }

    /**
     * Initialize the Directions Controller if location has directions enabled.
     * @param  {Array}   stops    Array of stops at current location.
     * @param  {boolean} isMobile True if on a mobile phone.
     */
    initDirections = (stops, isMobile) => {
        var self = this

        var $container = $('.directions-container' + (isMobile ? '.mobile' : '.desktop'))

        var $stopsList = $container.find('.stops-list')

        $stopsList.on('click', '.stop', function() {
            var stopid = $(this).attr('stopid')

            if (stopid === 'current_location') {
                self._directions.setStop(stopid)
            } else {
                self.selectStop(stopid)
            }

            // close directions if mobile and both fields have stops
            if (isMobile) {
                if (self._directions.hasBothStops()) {
                    self._directions.close()
                } else {
                    self._directions.closeList()
                }
            }
        })

        this._directions = new DirectionsController({
            isMobile: isMobile,
            stops: stops,
            container: $container,
            list: $stopsList,

            calculateDirections: function(start, end, callback, errorCallback) {
                MapAdapter.calculateDirections(start, end, callback, errorCallback)
            },

            onOpen: function() {
                // unselect tour
                self.selectTour('')

                // stop audio and hide tooltip
                self.stopAudio()
                MapAdapter.hideTooltip()

                $('#directionspanel').addClass('fullheight')
                $('#tourspanel').addClass('hide')
                $('#stopspanel').addClass('hide')

                if (isMobile) {
                    // hide other mobile menus
                    self.toggleDropMenu('.stopmenu', false)
                    self.toggleDropMenu('.tourmenu', false)
                }
            },
            onClose: function() {
                if ($('#mapTourSelection option:selected')[0] != $('#mapTourSelection option')[0]) {
                    self.selectTour($('#mapTourSelection option:selected').attr('trailid'))
                }

                $('#directionspanel').removeClass('fullheight')
                $('#tourspanel').removeClass('hide')
                $('#stopspanel').removeClass('hide')

                if (self._selectedStop) {
                    self.selectStop(self._selectedStop.id)
                }
            },
            onPath: function(path) {
                MapAdapter.setDirections(path)
            },
            onFieldFocus: function(stop) {
                if (stop) {
                    self.selectStop(stop.id)
                }
            },
            onSwap: function(stop) {},
            onError: function(message) {
                if (isMobile) {
                    var $error = $container.find('.path-error')

                    // show and hide banner popup on mobile
                    $error.text(message).addClass('show')

                    setTimeout(function() {
                        $error.removeClass('show')
                    }, 2000)
                } else {
                    self.alertMsg('Directions Error', message, false)
                }

                // clear path on error
                MapAdapter.setDirections([])
            },
        })
    }

    initShareButton = () => {
        var desktopParams = {
                shareButton: $('.share-container.map .share-btn'),
                shareLi: $('.share-container.map ul.social-icons li'),
            },
            mobileParams = {
                shareButton: $('.mobile-menu .share-btn'),
                shareLi: $('.mobile-menu ul.social-icons li, .share-object.share-btn-mobile-menu li'),
            }

        Common &&
            Common.registerShareObject(
                desktopParams,
                mobileParams,
                function() {
                    return {
                        params: '',
                        imageUrl: $('meta[name=fb-image]').attr('content'),
                        url: window.location.href,
                        longUrl: window.location.href,
                    }
                },
                false
            )
    }

    initMapMarkers = dataMarkers => {
        this.drawCircleEnabled = true
        for (var ii = 0; ii < dataMarkers.length; ++ii) {
            var lat = dataMarkers[ii].customPoint.lat()
            var lng = dataMarkers[ii].customPoint.lng()

            this.drawCircle(
                this.map,
                new google.maps.LatLng(lat, lng),
                (this.stopRange + 20) * this.multiplyer,
                30,
                '#00CD00',
                true
            )
        }
    }

    initStops = dataStops => {
        var controller = this
        this._stops = dataStops
        // stops = dataStops;
        var mediaStops = $('#stopspanel .stopmenu')

        var dropmenu = $('#map-dropmenudiv ul.stopmenu')
        if (dropmenu[0]) {
            dropmenu.empty()
        } else {
            dropmenu = $('<ul>').addClass('stopmenu')
            $('#map-dropmenudiv').append(dropmenu)
        }

        for (var ii = 0; ii < dataStops.length; ++ii) {
            var li = $('<li>' + dataStops[ii].title + '</li>')
                .attr('stopid', dataStops[ii].id)
                .click(() => {
                    this.selectStop(dataStops[ii].id)
                })

            var dropLi = $('<li>' + dataStops[ii].title + '</li>')
                .attr('stopid', dataStops[ii].id)
                .click(function() {
                    controller.selectStop($(this).attr('stopid'))
                    $('.button-stops').click()
                })
            mediaStops.append(li)
            dropmenu.append(dropLi)
        }

        $('.button-stops').click(function() {
            controller.toggleDropMenu('.stopmenu')

            //this part allows to close the scroll menu when clicking outside of it
            $(document).on('click', function(event) {
                if (
                    $(event.target).is('#map-dropmenudiv') ||
                    $(event.target).is('.button-stops-anchor') ||
                    $(event.target).is('.button-stops')
                ) {
                    return
                } else if ($(event.target).is('.button-tours-anchor') || $(event.target).is('.button-tours')) {
                    controller.toggleDropMenu('.tourmenu', true)
                    $(this).unbind(event)
                } else {
                    controller.toggleDropMenu('.stopmenu', false)
                    $(this).unbind(event)
                }
            })
        })

        $('#map-dropmenudiv').append(dropmenu)
    }
    getStops = () => {
        return this._stops
    }

    initTrails = dataTrails => {
        this.trails = dataTrails
        if (this.trails.length == 0) {
            $('#map-status .button-stops').css('margin-left', '40px')
        } else {
            $('#map-status .button-stops').css('margin-left', '0')
        }
        var controller = this
        var tours = $('#mapTourSelection').change(function() {
            MapAdapter.hideTooltip()
            controller.selectTour(
                $(this)
                    .find('option:selected')
                    .attr('trailid')
            )
        })

        var dropmenu = $('#map-dropmenudiv ul.tourmenu')
        if (dropmenu[0]) {
            dropmenu.empty()
        } else {
            dropmenu = $('<ul>').addClass('tourmenu')
            $('#map-dropmenudiv').append(dropmenu)
        }

        dropmenu.append(
            $('<li>')
                .html('Select...')
                .click(function() {
                    controller.selectTour()
                    $('.button-tours').click()
                    $('#mapTourSelection [trailid=]').prop('selected', 'true')
                })
        )
        for (var ii = 0; ii < dataTrails.length; ++ii) {
            var option = $('<option>')
                .html(dataTrails[ii].name)
                .attr('trailid', dataTrails[ii].id)

            var dropLi = $('<li>' + dataTrails[ii].name + '</li>')
                .attr('trailid', dataTrails[ii].id)
                .click(function() {
                    controller.selectTour($(this).attr('trailid'))
                    $('.button-tours').click()
                    $('#mapTourSelection [trailid=' + $(this).attr('trailid') + ']').prop('selected', 'true')
                })
            tours.append(option)
            dropmenu.append(dropLi)
        }
        $('.button-tours').click(function() {
            controller.toggleDropMenu('.tourmenu')

            //this part allows to close the scroll menu when clicking outside of it
            $(document).on('click', function(event) {
                if (
                    $(event.target).is('#map-dropmenudiv') ||
                    $(event.target).is('.button-tours-anchor') ||
                    $(event.target).is('.button-tours')
                ) {
                    return
                } else if ($(event.target).is('.button-stops-anchor') || $(event.target).is('.button-stops')) {
                    controller.toggleDropMenu('.stopmenu', true)
                    $(this).unbind(event)
                } else {
                    controller.toggleDropMenu('.tourmenu', false)
                    $(this).unbind(event)
                }
            })
        })

        $('#map-dropmenudiv').append(dropmenu)
    }

    set = (k, v) => {
        this.map && this.map.set(k, v)
    }

    initLocateMe = () => {
        var controller = this
        $('.button-locateMe').click(function() {
            controller.toggleDropMenu()
            controller.locateMe()
            controller.delegate.controller._firstRun = false
        })
    }

    getSelectedStop = () => {
        return this._selectedStop
    }

    toggleDropMenu = (menuClass, show) => {
        var buttonClass
        switch (menuClass) {
            case '.stopmenu':
                buttonClass = '.button-stops'
                break
            case '.tourmenu':
                buttonClass = '.button-tours'
                MapAdapter.setDirections([]) // hide directions when showing tours
                break
            default:
                $('#map-status [class*=button-]').removeClass('selected')
                $('#map-dropmenudiv').css('height', 0)
                $('#map-dropmenudiv').removeClass('open')
                return
        }

        if (typeof show === 'undefined') {
            show = !$(buttonClass).hasClass('selected')
        }

        if (show) {
            $('#map-dropmenudiv ul').hide()
            $(menuClass).show()
            $('#map-status [class*=button-]').removeClass('selected')
            $(buttonClass).addClass('selected')

            var height = Math.min($('#map-dropmenudiv ' + menuClass).height(), $('html').height() - 80)
            $('#map-dropmenudiv').css('height', height)
            $('#map-dropmenudiv').addClass('open')

            // close directions menu when showing other menus (ie: tours/stops menus)
            if (this._directions) {
                this._directions.close()
            }
        } else {
            $('#map-status [class*=button-]').removeClass('selected')
            $('#map-dropmenudiv').css('height', 0)
            $('#map-dropmenudiv').toggleClass('open')
        }
    }

    mapLoadingCompleted = () => {}
    stopAudio = id => {
        if (this._selectedStop != null) {
            this._stopAudio(this._selectedStop)
        }
        for (var ii = 0; ii < this._stops.length; ++ii) {
            if (this._stops[ii].id == id) {
                this._stopAudio(this._stops[ii])
            }
        }
    }
    playAudio = stopid => {
        this._selectStop(stopid)
        this._playAudio(this._selectedStop)
    }
    selectTour = trailid => {
        if (trailid == null) {
            MapAdapter.setTrail('')
        } else {
            MapAdapter.setTrail(trailid)
        }
    }

    onStopSelected = cb => {
        this._eventEmitter && this._eventEmitter.on(this.events.STOP_SELECTED, cb)
    }

    selectStop = (stopid, sendStopNotification) => {
        var notification = sendStopNotification == undefined ? true : sendStopNotification

        MapAdapter.selectStop(stopid, MapAdapter.automaticAudioEnabled, notification)
    }
    stopSelected = stopid => {
        this._selectStop(stopid)

        try {
            parent.postMessage('MAP_MESSAGE::' + stopid, parent.window.location.href)
        } catch (e) {
            // console.log(e)
        }
        // set directions stop if open
        if (this._directions && this._directions.isOpen()) {
            this._directions.setStop(stopid)
            MapAdapter.hideTooltip()
        }
    }
    stopEntered = stopid => {
        for (let ii = 0; ii < this._stops.length; ++ii) {
            if (this._stops[ii].id == stopid) {
                if (this._stops[ii].audio != null) this._playAudio(this._stops[ii])
                break
            }
        }
    }

    mapReady = () => {
        if (!this.map) return
        this._eventEmitter && this._eventEmitter.trigger(this.events.MAP_READY)

        this.resizeWindow()
        let stop
        if (this.startingStop != 0) {
            stop = this.getStopById(this.startingStop)
        }
        if (!stop) {
            stop = this._stops[0]
        }

        if (stop && stop.marker) {
            var disableAutoSelect = this._directions && this._directions.isOpen()

            if (!disableAutoSelect) {
                MapAdapter.selectStop(stop.id, MapAdapter.automaticAudioEnabled, false)
                this.map.panTo(stop.marker.position)
            }
        }

        if (this._gpsCollector) {
            this._gpsCollector.addListener(this._onLocationUpdate.bind(this))

            this._gpsCollector.addErrorListener(this._onLocationError.bind(this))

            this.locateMe(true)
        }
    }
    alertMsg = (title, msg, suppressAlert) => {
        if (suppressAlert) return
        if ($('#x-content')[0] == undefined) {
            $('body').append(
                $(
                    '<div id="x-content">' +
                        '<div class="msgbox">' +
                        '<div class="content">' +
                        '<div class="title"></div>' +
                        '<div class="text"></div>' +
                        '<div class="button"><div class="button-label">Ok</div></div>' +
                        '</div>' +
                        '</div>' +
                        '<div class="mask"></div>' +
                        '</div>'
                )
            )
            $('#x-content .button').click(function() {
                $('#x-content').hide()
            })
        }
        $('#x-content .title').html(title)
        $('#x-content .text').html(msg)
        $('#x-content').show()
    }
    locateMe = suppressAlert => {
        // EARLY EXIT - NO GPS SUPPORT
        if (!this._gpsCollector) {
            // NO GPS SUPPORT
            this.alertMsg('GPS Unsupported', 'GPS Location is not supported by this browser.', false)
            return
        }

        this.alertMsg('', 'Finding Location...', suppressAlert)

        // // GET POSITION RIGHT NOW
        this._gpsCollector.getPosition(
            this._onGetPosition.bind(this, suppressAlert),
            this._onGetPositionError.bind(this, suppressAlert)
        )
    }
    getZoom = () => {
        return this.map.getZoom()
    }
    resize = (zoom, timeout) => {
        clearTimeout(this.resizeTimeout)
        clearTimeout(this.panTimeout)

        this.resizeTimeout = setTimeout(() => {
            if (this.map) {
                const center = this.map.getCenter()
                this.map.setZoom(zoom)
                google.maps.event.trigger(this.map, 'resize')
                this.panTimeout = setTimeout(() => {
                    this.map && this.map.panTo(center)
                }, 250)
            }
        }, timeout)
    }
    isMobileDevice = () => {
        var mobile = Browser.is('mobile')
        return typeof mobile !== 'undefined' ? mobile : this.isMobilePhone || this.isTablet
    }
    _onGetPosition = (suppressAlert, gpsObject) => {
        if (this._gpsCollector && !this._gpsCollector.isGpsAccurate(gpsObject)) {
            this.alertMsg(
                '',
                'Cannot get an accurate GPS location at this point. Please try again later. ' +
                    'If you are standing indoors try going somewhere outdoor and try again.',
                suppressAlert
            )
            return
        }

        if (this._gpsCollector && !this._gpsCollector.isGpsInBounds(gpsObject)) {
            this.alertMsg('', 'Your location is outside the campus boundaries.', suppressAlert)
            return
        }

        // RECENTER MAP
        MapAdapter.setGPSCoordinates(gpsObject.lat, gpsObject.lng, true, gpsObject.accuracy)

        // HIDE THE POPUP
        $('#x-content').hide()
    }
    _onGetPositionError = (suppressAlert, positionError) => {
        this.alertMsg('GPS Update', 'Unable to find your current location', suppressAlert)
    }

    _onLocationUpdate = gpsObject => {
        if (
            this._gpsCollector &&
            this._gpsCollector.isGpsWithinAudioAccuracy(gpsObject) &&
            this._recenterOnAccurateGPSUpdate
        ) {
            // RECENTER MAP
            MapAdapter.setGPSCoordinates(gpsObject.lat, gpsObject.lng, true, gpsObject.accuracy)
            this._recenterOnAccurateGPSUpdate = false
        } else {
            // DO NOT RECENTER MAP
            MapAdapter.setGPSCoordinates(gpsObject.lat, gpsObject.lng, false, gpsObject.accuracy)
        }
    }
    _onLocationError = positionError => {
        switch (positionError.code) {
            case positionError.PERMISSION_DENIED:
                console.log('GPS permission denied: ' + this.delegate.controller._firstRun)
                this.delegate.controller.alertMsg(
                    'GPS Disabled',
                    'Please Enable GPS Location Tracking to use this feature',
                    this.delegate.controller._firstRun
                )
                break
            case positionError.TIMEOUT:
                console.log('GPS timed out. ' + positionError.message)
                break
            default:
                console.log('GPS Error occurred.')
        }
    }

    _selectStop = stopid => {
        for (let ii = 0; ii < this._stops.length; ++ii) {
            if (this._stops[ii].id == stopid) {
                this._selectedStop = this._stops[ii]

                this._eventEmitter.trigger(this.events.STOP_SELECTED, [this._selectedStop])
            }
        }
    }
    _playAudio = stop => {
        $('.button-audio').addClass('play')
        this.player.setUrl(stop.audio)
        this.player._activeAudioId = stop.id
        this._currentAudioId = stop.id
        this.player.play()
    }
    _stopAudio = stop => {
        $('.button-audio').removeClass('play')
        this.player.stop()
    }
    _onAudioPlayerPlay = player => {
        this._currentAudioId = player._activeAudioId
    }
    _onAudioPlayerStop = player => {
        this._currentAudioId = null
        $('.button-audio').removeClass('play')
    }
    _onAudioPlayerEnded = player => {
        this._onAudioPlayerStop(player)
    }
    campusMapInit = (controller, gmap, multi, wpRange, hasGoogleMap) => {
        const self = this
        MapAdapter.hasGoogleMap = hasGoogleMap
        this.initMapVariables(controller)
        this.delegate.determineDeviceType()
        this.coordinateMapType.clearCache()

        if (this.isMobileDevice()) {
            document.documentElement.style.webkitTapHighlightColor = 'rgba(0,0,0,0)'
            document.documentElement.style.webkitTouchCallout = 'none'
            document.documentElement.style.webkitUserSelect = 'none'
        }

        this.delegate.initGoogleMap(gmap, this.mapZoom, this.mapCenter)

        if (!hasGoogleMap) {
            this.map.mapTypes.set('coordinate', this.coordinateMapType)
            this.map.setMapTypeId('coordinate')
        }

        $(window).resize(() => {
            this.resizeWindow()
            if (this.map.activeTooltip) this.map.activeTooltip.responsive()
        })
        if (typeof MediaModules != 'undefined') {
            MediaModules.onClose(() => {
                if (this.currentStop && this.delegate.shouldPlayAudio) {
                    this.delegate.playAudio(this.currentStop.id)
                }
            })
        }
        const TooltipOverlay = require('./tooltipOverlay').default
        this.tooltipOverlay = new TooltipOverlay(self.map)

        this.multiplyer = multi
        this.stopRange = wpRange

        google.maps.event.addListener(this.map, 'click', function(mouseEvent) {
            MapAdapter.mapClicked(self.map, mouseEvent.latLng)
        })

        // const is = this.initializeStops.bind(this)

        this.initTimeout = setTimeout(this.initializeStops, 2000)
        this.loadingCompleted()
    }
    showMarkers = visible => {
        if (visible == this.markersVisible) return
        for (var ii = 0; ii < this._stops.length; ii++) {
            try {
                if (visible) this._stops[ii].marker.setMap(this.map)
                else this._stops[ii].marker.setMap(null)
            } catch (err) {
                // console.log(err)
            }
        }
        this.markersVisible = visible
    }
    resizeWindow = () => {
        if (this.hasPolygons && $(window).width() > 1024) {
            this.showMarkers(false)
        } else {
            this.showMarkers(true)
        }
    }
    initMapVariables = controller => {
        // SVG Path for start/end point (similar to YouVisit logo)
        var pointerSvg =
            'M48.000,128.000 C46.742,128.000 45.555,127.406 44.801,126.398 L10.320,77.754 L9.059,75.984 C3.137,67.762 0.000,58.082 0.000,48.000 C0.000,21.531 21.531,0.000 48.000,0.000 C74.469,0.000 96.000,21.531 96.000,48.000 C96.000,58.082 92.863,67.762 86.930,76.000 L85.254,78.328 L51.199,126.398 C50.445,127.406 49.258,128.000 48.000,128.000 ZM48.000,32.000 C39.176,32.000 32.000,39.176 32.000,48.000 C32.000,56.824 39.176,64.000 48.000,64.000 C56.824,64.000 64.000,56.824 64.000,48.000 C64.000,39.176 56.824,32.000 48.000,32.000 Z'

        // Reset global variable
        this.latestStops = new Array()
        this.locationMarker = null
        this.lastRealLocation = null
        this.activeStop = null
        this.currentTrail = null
        this.stopIdPlaying = ''
        this.selectedStop = null
        this.accuracyCircle = null
        this.preventClickPropogation = false

        this.delegate = new WebMapDelegate(controller)
        this.stopShadowIcon = new google.maps.MarkerImage(
            this.delegate.getPath('images/waypointshadow.png'),
            new google.maps.Size(19, 22),
            new google.maps.Point(0, 0),
            new google.maps.Point(0, 31)
        )
        this.stopIcon = new google.maps.MarkerImage(
            this.delegate.getPath('images/mapIconShadow.png'),
            new google.maps.Size(44, 33),
            new google.maps.Point(0, 0),
            new google.maps.Point(7, 33)
        )

        this.startTrailIcon = {
            path: pointerSvg,
            anchor: new google.maps.Point(47, 124),
            fillColor: '#14B300',
            fillOpacity: 1,
            strokeWeight: 3,
            scale: 0.268,
            strokeColor: 'white',
            strokeOpacity: 1,
        }
        this.endTrailIcon = {
            path: pointerSvg,
            anchor: new google.maps.Point(47, 124),
            fillColor: '#ED145B',
            fillOpacity: 1,
            strokeWeight: 3,
            scale: 0.268,
            strokeColor: 'white',
            strokeOpacity: 1,
        }
        this.activeStopShadowIcon = new google.maps.MarkerImage(
            this.delegate.getPath('images/waypointshadow.png'),
            new google.maps.Size(19, 22),
            new google.maps.Point(0, 0),
            new google.maps.Point(0, 31)
        )
        this.activeStopIcon = new google.maps.MarkerImage(
            this.delegate.getPath('images/activewaypoint.png'),
            new google.maps.Size(32, 33),
            new google.maps.Point(0, 0),
            new google.maps.Point(0, 33)
        )
        this.gpsIcon = new google.maps.MarkerImage(
            this.delegate.getPath('images/gps.png'),
            new google.maps.Size(19, 19),
            new google.maps.Point(0, 0),
            new google.maps.Point(8, 8)
        )
    }

    loadStops = () => {
        if (!this.map) return
        const self = this
        var i = 0
        var currentStop
        var RichMarker = require('../richmarker').default
        for (i = 0; i < this._stops.length; i++) {
            currentStop = this._stops[i]
            var marker = new RichMarker({
                position: new google.maps.LatLng(currentStop.customlat, currentStop.customlng),
                content:
                    '<div class="marker" id="stop_' +
                    currentStop.id +
                    '" data-title="' +
                    currentStop.title +
                    '" style="color: ' +
                    (this.selectedStop && this.selectedStop.id == currentStop.id
                        ? MapAdapter.MarkerColors.current.selected
                        : MapAdapter.MarkerColors.current.default) +
                    '; background:rgba(0,0,0,0);">L</div>',
            })
            google.maps.event.addListener(
                marker,
                'click',
                MapAdapter.selectStop.bind(null, currentStop.id, self.automaticAudioEnabled)
            )
            marker.setMap(self.map)

            currentStop.marker = marker
            this.createHoverMarker(currentStop)
            if (this.drawCircleEnabled) {
                this.drawCircle(
                    this.map,
                    new google.maps.LatLng(currentStop.customlat, currentStop.customlng),
                    (this.stopRange + currentStop.radius) * this.multiplyer,
                    30,
                    '#0b64b3',
                    true
                )
            }
        }
    }
    initializeStops = () => {
        this.initTimeout = null
        this.loadStops()
        this.addStopsToMarkers()
        this.addLabelsToMarkers()
        this.delegate.mapReady()
    }

    drawCircle = (map, center, radius, numPoints, color, fill) => {
        var circle = new google.maps.Circle({
            center: center,
            radius: radius,
            strokeColor: color,
            strokeWeight: 3,
            strokeOpacity: 0.8,
            fillColor: color,
            fillOpacity: fill ? 0.3 : 0,
            clickable: false,
        })
        circle.setMap(map)
        return circle
    }

    createHoverMarker = stop => {
        if (stop.shape != null && stop.shape.getPath().getLength() > 0) {
            stop.tooltip = '<div><nobr>' + stop.title + '</nobr></div>'
            var options = {
                fillColor: this.hoverColor,
                fillOpacity: 0.0,
                strokeColor: this.hoverColor,
                strokeWeight: 2,
                strokeOpacity: 0.0,
            }
            stop.shape.setOptions(options)
            stop.shape.setMap(this.map)

            google.maps.event.addListener(
                stop.shape,
                'click',
                MapAdapter.selectStop.bind(this, stop.id, this.automaticAudioEnabled, true)
            )

            if (!this.isMobileDevice()) {
                google.maps.event.addListener(
                    stop.marker,
                    'mouseover',
                    this.updateHover.bind(this, stop.id, true, true)
                )
                google.maps.event.addListener(stop.shape, 'mouseover', this.updateHover.bind(this, stop.id, true, true))
                google.maps.event.addListener(
                    stop.marker,
                    'mouseout',
                    this.updateHover.bind(this, stop.id, false, false)
                )
                google.maps.event.addListener(
                    stop.shape,
                    'mouseout',
                    this.updateHover.bind(this, stop.id, false, false)
                )
            }
        } else {
            google.maps.event.addListener(stop.marker, 'mouseover', this.updateHover.bind(this, stop.id, true, true))
            google.maps.event.addListener(stop.marker, 'mouseout', this.updateHover.bind(this, stop.id, false, false))
        }
    }

    loadingCompleted = () => {
        this.delegate.loadingCompleted()
    }

    // playAudio(id) {
    //     this.delegate.playAudio(id)
    // }

    // stopSelected(wp) {
    //     this.delegate.stopSelected(wp)
    // }

    stopEnteredEvent = wp => {
        this.delegate.stopEnteredEvent(wp)
    }

    stopChangedEvent = (wpBefore, wpAfter) => {
        this.delegate.stopChangedEvent(wpBefore, wpAfter)
        MapAdapter.selectStop(wpAfter.id, this.automaticAudioEnabled, false)
    }

    showStop = stopid => {
        this.delegate.showStop(stopid)
    }

    updateHover = (stopId, hoverOn, showTooltip) => {
        var stop = this.getStopById(stopId)
        var options

        if (stop.markerLabel) {
            stop.markerLabel.setHover(hoverOn)
            if (this.map.getZoom() == 9) {
                stop.markerLabel && stop.markerLabel.setVisible(hoverOn)
            }
        }

        if (stop.shape == null) {
            return
        }
        if (hoverOn) {
            if (this.currentHoverStopId != -1 && this.currentHoverStopId != stopId) {
                this.updateHover(this.currentHoverStopId, false, false)
            }
            options = {
                fillOpacity: 0.5,
                strokeWeight: 3,
                strokeOpacity: 0.5,
            }
            stop.shape.setOptions(options)
        } else if (this.currentStop == undefined || this.currentStop.id != stopId) {
            options = {
                fillOpacity: 0.0,
                strokeWeight: 2,
                strokeOpacity: 0.0,
            }
            stop.shape.setOptions(options)
        }

        this.tooltip = $('#map_tooltip')
        if (showTooltip && !this.isMobileDevice()) {
            this.tooltip.html(stop.tooltip)
            var proj = this.tooltipOverlay.getProjection()
            var point = proj.fromLatLngToDivPixel(stop.bounds.getNorthEast())

            var adjust = this.toolTipOverlap(point, this.tooltip)
            this.tooltip.css({
                top: point.y + adjust.y + 'px',
                left: point.x + adjust.x + 'px',
                border: '1x solid #ffffff',
            })
            this.tooltip.addClass('opaque')
        } else {
            if (this.tooltip) this.tooltip.removeClass('opaque')
        }
    }

    addStopsToMarkers = () => {
        var i = 0
        for (i = 0; i < this._stops.length; i++) {
            this.mapMarkers.push(
                new MapMarker(
                    this._stops[i].customlat,
                    this._stops[i].customlng,
                    this._stops[i].reallat,
                    this._stops[i].reallng
                )
            )
        }
    }

    addLabelsToMarkers = () => {
        const scope = this
        if (!scope.map) return
        if (this.delegate.controller.isFullMap()) {
            var currentStop
            var CustomMarkerLabel = require('./customMarkerLabel').default
            for (var index in this._stops) {
                currentStop = this._stops[index]
                currentStop.markerLabel = new CustomMarkerLabel({
                    title: currentStop.title,
                    visible: scope.map.getZoom() != 9,
                    map: scope.map,
                    latlng: currentStop.marker.getPosition(),
                })
            }

            google.maps.event.addDomListener(scope.map, 'zoom_changed', function() {
                for (var index in scope._stops) {
                    scope._stops[index].markerLabel.setVisible(scope.map.getZoom() != 9)
                }
            })
        }
    }

    showStopInfoPopup = (stop, recenter) => {
        if (!this.map) return
        var marker = stop.marker
        if (this.delegate.controller.isFullMap()) {
            if (marker) {
                this.map.panTo(marker.getPosition())
            }
        } else {
            if (this.map.activeTooltip != null) {
                this.map.activeTooltip.setMap(null)
                this.map.activeTooltip = null
            }
            var bubbleText = new BubbleText(stop)
            const InfoBox = require('./popupmarker').default
            console.log('Stopss', stop.shape && !this.markersVisible ? stop.center : marker.getPosition())
            this.map.activeTooltip = new InfoBox({
                id: stop.id,
                bubbleText: bubbleText,
                recenter: recenter,
                latlng: stop.shape && !this.markersVisible ? stop.center : marker.getPosition(),
                map: this.map,
                resourcesPath: this.delegate.getPath(''),
                descriptionHidden: false,
                mapController: this.delegate.controller,
            })
        }
    }

    mapClicked = map => {
        return MapAdapter.mapClicked(map)
    }
    // end
}

export default new MapController()
